// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1f99eee1","879":"c98e88dd"}[chunkId] + ".chunk.js";
};